<template>
<div id="catalogos_proveedores">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-row align-center justify-center>
            <v-col xs="12">
                <base-material-card color="primary" icon="mdi-google-maps" title="Administrar Ubicaciones" class="elevation-1 px-5 py-3">
                    <v-card-actions>
                        <v-spacer />

                        <v-btn fab dark x-small color="primary" slot="activator" @click.native="agregar" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-card-text>
                        <div id="datagrid">
                            <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                </template>
                                <template slot="actions" slot-scope="props">
                                    <v-btn x-small fab dark color="success" @click.native="editar(props.row.uuid)" title="Editar Registro" v-tippy>
                                        <v-icon>edit</v-icon>
                                    </v-btn>&nbsp;
                                    <v-btn x-small fab dark color="pink" @click.native="eliminar(props.row.uuid)" title="Eliminar Registro" v-tippy>
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-col>
        </v-row>
    </v-container>
    <v-dialog v-model="modal" max-width="60%">
        <v-card>
            <v-card-title>
                <span class="headline">{{ tituloModal }}</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-form ref="form">
                        <v-card>
                            <v-card-text>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.identificador" label="Identificador (6 digitos)" :rules="[this.$rules.required, validaEntero]" minlength="6" maxlength="6"></v-text-field>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.descripcion" label="Descripción" :rules="[this.$rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.rfc" label="RFC/TAX ID" :rules="[this.$rules.required]" maxlength="30"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-text-field v-model="model.domicilio.codigo_postal" label="Codigo Postal" @blur="searchCP" :rules="[validaEntero]" maxlength="5"></v-text-field>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.domicilio.pais" label="País" :rules="[this.$rules.required]" :loading="loadPais" @change="cargarEstados(model.domicilio.pais)" :items="sat_paises" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.domicilio.estado" label="Estado" :rules="[this.$rules.required]" :loading="loadEstado" @change="cargarMunicipios(model.domicilio.estado); cargarLocalidades(model.domicilio.estado)" :items="sat_estados" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.domicilio.municipio" label="Municipio" :rules="[this.$rules.required]" @change="sat_colonias=[]; searchColoniasCombo()" :loading="loadMunicipio" :items="sat_municipios" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.domicilio.localidad" label="Localidad" :loading="loadLocalidad" @change="sat_colonias=[]; searchColoniasCombo()" :items="sat_localidades" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                                    </v-col>
                                    <v-col sm="4" md="4" lg="4">
                                        <v-autocomplete v-model="model.domicilio.colonia" label="Colonia" :loading="loadColonia" :items="sat_colonias" :hide-no-data="true" item-text="nombre" item-value="clave"></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-text-field v-model="model.domicilio.calle" label="Calle" :rules="[this.$rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col sm="3" md="3" lg="3">
                                        <v-text-field v-model="model.domicilio.numero_ext" label="No. Exterior" :rules="[this.$rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col sm="3" md="3" lg="3">
                                        <v-text-field v-model="model.domicilio.numero_int" label="No. Interior"></v-text-field>
                                    </v-col>
                                </v-row>

                            </v-card-text>
                        </v-card>

                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="default" small @click="modal=false">
                    <v-icon small>mdi-cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" small @click="guardar">
                    <v-icon small>mdi-check-circle-outline</v-icon> Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    name: "DashboardDataTables",
    created: function () {
        this.URL = this.$hostname + "carta_porte/catalogos/";
        this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";
        this.model = this.clean_model();
       
        this.cargarPaises();
        this.cargar();
    },
    computed: {
        tituloModal() {
            return this.updateModel === false ? "Nueva Ubicación" : "Editar Ubicación";
        },
    },
    data: () => ({
        URL:"",
        URL_SAT:"",
        sat_paises: [],
        sat_estados: [],
        sat_localidades: [],
        sat_municipios: [],
        sat_colonias: [],
        loadPais: false,
        loadLocalidad: false,
        loadEstado: false,
        loadMunicipio: false,
        loadColonia: false,

        tabla: "ubicaciones",
        modal: false,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "Ubicaciones",
                disabled: true,
                href: "",
            },
        ],
        model: {},
        updateModel: false,
        columns: ["identificador", "rfc", "descripcion", "actions"],
        options: {
            filterable: true,
            headings: {
                rfc: "RFC/TAX ID",
                identificador: "Identificador",
                descripcion: "Descripción",
                actions: "Operaciones"
            }
        },
        items: [],
        search: undefined,

    }),
    methods: {
        searchCP: async function () {
            var val = this.model.domicilio.codigo_postal;
            if (val != null && val.toString().trim() != "" && val.toString().trim().length >= 4) {
                var cp = val.toString().trim();
                if (cp.length == 4) {
                    cp = "0" + cp;
                } else if (cp.length > 5) {
                    return false;
                }

                //console.log("CP: ",cp);        

                //TODO: Buscar codigo postal, traer estado, municipio, localidad para llenar esos combos
                var params = {
                    filtros:{
                        clave: cp,
                    },                    
                };

                var self = this;
                this.$axios.post(this.URL_SAT + "list_codigos_postales/", params)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            var codigo = res.data[0];

                            //Buscar estado                
                            self.sat_estados = [];
                            self.searchEstado(codigo);

                            //Buscar municipio                
                            self.sat_municipios = [];
                            self.searchMunicipio(codigo);

                            //Buscar localidad                
                            self.sat_localidades = [];
                            self.searchLocalidad(codigo);                       
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "Error",
                            text: "Ocurrió un error al buscar Código Postal.",
                            footer: "",
                        });
                        console.log(err);
                    });

                //Buscar Colonias        
                self.sat_colonias = [];
                this.searchColonias(cp);
            }
        },
        searchColonias: function (cp) {
            var self = this;
            self.loadColonia = true;
            
            var params = {
                filtros:{
                    codigo_postal: cp,
                }                
            };
            
            this.$axios.post(this.URL_SAT + "list_colonias/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_colonias = res.data.sort(function (a, b) {
                            if (a.nombre > b.nombre)
                                return 1;
                            if (a.nombre < b.nombre)
                                return -1;
                            return 0;
                        });                  
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al buscar las colonias.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadColonia = false;
                });

        },
        searchColoniasCombo: function () {
            var self = this;
            if ((self.model.domicilio.codigo_postal == null || self.model.domicilio.codigo_postal == "") &&
                self.model.domicilio.estado != null && self.model.domicilio.municipio != null &&
                self.model.domicilio.localidad != null) {

                self.loadColonia = true;
                
                let params = {
                    filtros: {
                        clave_estado: self.model.domicilio.estado,
                        clave_municipio:self.model.domicilio.municipio,
                        clave_localidad:self.model.domicilio.localidad
                    }
                }
                this.$axios.post(this.URL_SAT + "list_codigos_postales/", params)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            var codigos = res.data;                            
                            codigos.forEach(element => {
                                self.searchColonias(element["clave"]);
                            });
                        } else
                            self.loadColonia = false;
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "Error",
                            text: "Ocurrió un error al buscar codigo postal para colonias.",
                            footer: "",
                        });
                        console.log(err);
                    });               
            }
        },
        getColonia: function (clave, cp) {
            var self = this;
            self.loadColonia = true;
            var params = {
                filtros: {
                    clave: clave,
                    codigo_postal: cp,
                },
            };

            this.$axios.post(this.URL_SAT + "list_colonias/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_colonias = res.data;
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener la colonia.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadColonia = false;
                });
        },

        searchEstado: function (codigo) {
            var self = this;
            self.loadEstado = true;
            
            var params = {
                filtros:{
                    clave: codigo["clave_estado"]
                }                
            };

            this.$axios.post(this.URL_SAT + "list_estados/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.model.domicilio.pais = res.data[0]["clave_pais"];
                        self.cargarEstados(self.model.domicilio.pais);
                        self.model.domicilio.estado = res.data[0]["clave"];
                        self.cargarMunicipios(self.model.domicilio.estado);
                        self.cargarLocalidades(self.model.domicilio.estado);
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al buscar el estado.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadEstado = false;
                });            

        },
        searchMunicipio: function (codigo) {
            var self = this;
            self.loadMunicipio = true;            
            var params = {
                filtros:{
                    clave:codigo["clave_municipio"],
                    estado:codigo["clave_estado"]
                }                
            };
            
            this.$axios.post(this.URL_SAT + "list_municipios/", params)
                .then(res => {
                    if (typeof res.data !== "undefined" && res.data.length>0) {
                        self.model.domicilio.municipio = res.data[0]["clave"];
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al buscar el municipio.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadMunicipio = false;
                });    
         
        },
        searchLocalidad: function (codigo) {
            var self = this;
            if (codigo["clave_localidad"] != null && codigo["clave_localidad"] != "") {
                self.loadLocalidad = true;                
                var params = {
                    filtros:{
                        clave: codigo["clave_localidad"],
                        clave_estado: codigo["clave_estado"]
                    }                    
                };
                this.$axios.post(this.URL_SAT + "list_localidades/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.model.domicilio.localidad = res.data[0]["clave"];
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al buscar la localidad.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadLocalidad = false;
                });                 
            }
        },
        cargarPaises: function () {
            var self = this;
            self.loadPais = true;
            self.sat_paises = [];
            this.$axios.post(this.URL_SAT + "list_paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_paises = res.data.sort(function (a, b) {
                            if (a.nombre > b.nombre)
                                return 1;
                            if (a.nombre < b.nombre)
                                return -1;
                            return 0;
                        });
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los países.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadPais = false;
                });              
        },
        cargarEstados: function (clave_pais) {
            //console.log("CARGAR ESTADOS");
            var params = {
                filtros:{
                    clave_pais: clave_pais
                }                
            };
            var self = this;
            self.loadEstado = true;
            self.sat_estados = [];
            this.$axios.post(this.URL_SAT + "list_estados/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_estados = res.data.sort(function (a, b) {
                            if (a.nombre > b.nombre)
                                return 1;
                            if (a.nombre < b.nombre)
                                return -1;
                            return 0;
                        });
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los estados.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadEstado = false;
                }); 
            
        },
        cargarMunicipios: function (clave_estado) {
            var params = {
                filtros:{
                    estado: clave_estado
                }                
            };
            var self = this;
            self.loadMunicipio = true;
            self.sat_municipios = [];
            this.$axios.post(this.URL_SAT + "list_municipios/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_municipios = res.data.sort(function (a, b) {
                            if (a.nombre > b.nombre)
                                return 1;
                            if (a.nombre < b.nombre)
                                return -1;
                            return 0;
                        });
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los municipios.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadMunicipio = false;
                }); 
            
        },
        cargarLocalidades: function (clave_estado) {
            var params = {
                filtros:{
                    clave_estado: clave_estado
                }                
            };
            var self = this;
            self.loadLocalidad = true;
            self.sat_localidades = [];
            this.$axios.post(this.URL_SAT + "list_localidades/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.sat_localidades = res.data.sort(function (a, b) {
                            if (a.nombre > b.nombre)
                                return 1;
                            if (a.nombre < b.nombre)
                                return -1;
                            return 0;
                        });
                    }
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener las localidades.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.loadLocalidad = false;
                }); 
            
        },

        validaEntero: function (value) {
            const pattern = /^[\d]*$/;
            if (value != null && !pattern.test(value)) {
                return "Solo se acepta números";
            } else
                return true;
        },
        cargar: function () {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            
            let data = {
                uuid_empresa: this.model.uuid_empresa,
            };

            var self = this;
            this.$axios.post(this.URL + "list_ubicaciones/", data)
                    .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.items = res.data;
                        /*this.datos.sort(function(a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
                        }*/
                    }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "Error",
                            text: "Ocurrió un error al obtener los registros.",
                            footer: "",
                        });
                        console.log(err);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });                      
        },

        agregar: function () {
            this.model = this.clean_model();
            this.updateModel = false;
            this.modal = true;

        },
        editar: function (id) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;
            this.model = this.clean_model();
            var data = {                
                uuid: id,
                uuid_empresa: this.model.uuid_empresa,
            };
            this.$axios.post(this.URL + "list_ubicaciones/", data)
                .then(res => {
                if (typeof res.data !== "undefined") {
                    self.model = res.data[0];
                    //self.indexSeleccionado = self.model.uuid;
                    
                    if(self.model.domicilio.codigo_postal!=null && self.model.domicilio.codigo_postal!="")
                        self.searchColonias(self.model.domicilio.codigo_postal);
                    else 
                        self.searchColoniasCombo();
                    if(self.model.domicilio.pais!=null && self.model.domicilio.pais!="")        
                        self.cargarEstados(self.model.domicilio.pais);
                    if(self.model.domicilio.estado!=null && self.model.domicilio.estado!=""){
                        self.cargarMunicipios(self.model.domicilio.estado);
                        self.cargarLocalidades(self.model.domicilio.estado);
                    }
                    
                    this.modal = true;
                    this.updateModel = true;
                }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener el registro.",
                        footer: "",
                    });
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        eliminar: function (id) {
            var self = this;
            self.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show("Espere un momento por favor..");
                    var data = {
                        uuid: id,                        
                    };
                    this.$axios.post(this.URL + "delete_ubicacion/", data)
                        .then(res => {
                            self.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El registro se eliminó correctamente.",
                                footer: "",
                            });
                            self.cargar();
                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "Error",
                                text: "Ocurrió un error al eliminar el registro.",
                                footer: "",
                            });
                            console.log(err);
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                    
                }
            });

        },
        guardar: function () {
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("Espere un momento por favor..");
                var url = this.URL + "create_ubicacion/";
                                
                if (this.updateModel === false) 
                    this.model.uuid = this.$uuid.v4();
                else 
                    url = this.URL + "update_ubicacion/";
                    
                var self = this;
                this.$axios.post(url, this.model)
                    .then(res => {                    
                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se guardó correctamente.",
                            footer: "",
                        });
                        self.modal = false;                                          
                    })
                    .catch(err => {
                        console.log(err);
                        self.$swal({
                            type: "error",
                            title: "Error",
                            text: "Ocurrió un error al guardar el registro.",
                            footer: "",
                        });                        
                    }).then(() => {
                        this.add_registro = false;
                        self.cargar();
                        this.$root.$dialogLoader.hide();
                    });                  
                            
            }
        },
        clean_model: function () {
            this.sat_estados = [];
            this.sat_municipios = [];
            this.sat_localidades = [];
            this.sat_colonias = [];
            return {
                uuid: "",
                uuid_empresa: this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa"))),
                rfc: "",
                identificador: "",
                descripcion: "",
                domicilio: {
                    calle: "",
                    numero_int: "",
                    numero_ext: "",
                    colonia: "",
                    localidad: "",
                    municipio: "",
                    estado: "",
                    pais: "",
                    codigo_postal: ""
                },
            };
        }
    },
};
</script>
